import { PotentialIssue } from '@server/homepage';
import { Button } from '@sweep-io/sweep-design';
import { appRoutes } from '../../../../constants/appRoutes';
import buildURLQuery from '../../../../lib/buildURLQuery';
import { sendBiEvent } from '../../../../services/bi';
import { HOMEPAGE_EVENTS } from '../../../../services/events';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../../../reducers/userInfoReducer';
import { ButtonSize, ButtonVariants } from '@sweep-io/sweep-design/dist/components/Button/types';
import { buildConfigurationItemId } from '../../../documentation/dependencies/helpers';
import { DeepLinkSearchParams } from '@server/deep-link-search-params';
import { ConfigurationTypeToDocumentationTabType } from '../../../../types/enums/DocumentationTabTypes';
import { ConfigurationType } from '../../../documentation/dependencies/types';

interface ExploreWithAiButtonProps {
  issue: PotentialIssue;
  buttonVariant?: ButtonVariants;
  buttonSize?: ButtonSize;
}

export const ExploreWithAiButton = ({
  issue,
  buttonVariant = 'flat',
  buttonSize = 'tiny',
}: ExploreWithAiButtonProps) => {
  const currentCrmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const crmOrgId = currentCrmOrgId ?? '';
  const navigate = useNavigate();

  return (
    <Button
      variant={buttonVariant}
      size={buttonSize}
      onClick={(event) => {
        event.stopPropagation();
        const configurationType = issue.configurationType as unknown as ConfigurationType;
        const activeTab =
          ConfigurationTypeToDocumentationTabType[
            configurationType as keyof typeof ConfigurationTypeToDocumentationTabType
          ];
        const queryParams = buildURLQuery({
          [DeepLinkSearchParams.configurationItemId]: buildConfigurationItemId({
            parentType: issue.configurationType,
            name: issue.configurationName,
          }),
          [DeepLinkSearchParams.objectName]: issue.objectName,
          [DeepLinkSearchParams.activeTab]: activeTab,
          [DeepLinkSearchParams.apexClassParentId]: issue.apexClassParentId,
        });
        sendBiEvent({ name: HOMEPAGE_EVENTS.exploreWithAi });
        navigate(`${appRoutes.documentation.route}/${crmOrgId}?${queryParams}`);
      }}
    >
      Explore with AI
    </Button>
  );
};
